// extracted by mini-css-extract-plugin
export default {"section":"FilesContent_section__4x5kB","header":"FilesContent_header__p3Oi4"};